import React from 'react';
import moment from 'moment';

const renderTableBody = (headers, data, checkbox, openDetails) => {
    const body = data.map((user, index) => {
        return (
            <tr key={index}>

                {headers[0].value && <td>{user.empID ?? ''}</td>}
                {headers[1].value && <td>{user.firstName ?? ''} {user.lastName ?? ''}</td>}
                {headers[2].value && <td>{user?.email ?? ''}</td>}


                <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                    <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                        onClick={() => openDetails(user)}
                        style={{ fontWeight: '500' }}>
                        <i className="far fa-file-alt">
                        </i> Ver Detalles
                    </button>
                </td>
            </tr>
        )

    })
    return body;
};

const renderTable = (headers, data, checkbox, openDetails) => {

    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            {headers[0].value && <td style={{ width: '10%' }}>{headers[0].title}</td>}
            {headers[1].value && <td>{headers[1].title}</td>}
            {headers[2].value && <td>{headers[2].title}</td>}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>

        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};

export const renderMVentasAdminUser = (headers, data, checkbox, openDetails) => {

    return renderTable(headers, data, checkbox, openDetails);

}